import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ForgotpasswordThankyou.css";

class ForgoutpasswordThankyou extends Component {
	render() {
		return (
			<React.Fragment>
				<Container>
					<Row className="equal-space logoutpage">
						<Col className=" message-box mx-auto" md={10} sm={12}>
							<div className=" mx-auto col-md-7 col-sm-12">
								<h3 className="txt-orange">Thank You</h3>
								<p>
									As per your request, you will receive an email with a link to
									reset your password.
								</p>
								<Link to="/Login" className="cmn-btn">
									Login
								</Link>
								<Link to="/" className="cmn-btn">
									Home
								</Link>
							</div>
						</Col>
					</Row>
				</Container>
			</React.Fragment>
		);
	}
}
export default ForgoutpasswordThankyou;
